import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const excludedCountries = [];

const buttonVariations = [
  {
    label: <>Tangem Secure Crypto Wallets</>,
    title: <>Tangem: Your secure crypto hardware wallet</>,
    content: <>
    Tangem keeps your crypto safe and offline. Store, buy, earn, send, swap, and
    spend thousands of tokens. The highest chip security, counterfeit protection,
    and two-factor authentication.
    </>,
    href: "https://api.xrpscan.com/api/v1/campaign/tangembutton1",
  },
]

let variantIndex = 0;
try {
  variantIndex = Math.floor(Math.random() * buttonVariations.length);
} catch (error) {}
const buttonVariation = buttonVariations[variantIndex];

const TangemButton = (props) => {
  const { location } = props;
  if (!location || excludedCountries.includes(location)) {
    return <></>
  }

  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        {buttonVariation.title}
        <span className="small ml-1"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>{buttonVariation.content}</Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href={buttonVariation.href}
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >{buttonVariation.label}</Button>
        </OverlayTrigger>
    </span>
  )
}

TangemButton.propTypes = {
  location: PropTypes.string.isRequired,
}

export default TangemButton;